import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/patientRoom',
  component: Layout,
  name: 'patientRoom',
  // redirect: 'patientRoom/main/:id',
  children: [{
    path: '/patientRoom',
    component: () => import('@/views/patientRoom/index'),
    name: 'patientRoom.index',
    meta: {
      title: 'Кабинет пациенты'
    },
    children: [
    {
      path: '/patientRoom/:id',
      component: () => import('@/views/patientRoom/components/index'),
      name: 'patientHome',
      meta: {
        title: 'История пациентов'
      }
    },
    {
      path: '/patientRoom/hospitalization/:id',
      component: () => import('@/views/patientRoom/components/hospitalization'),
      name: 'hospitalization',
      meta: {
        title: 'История пациентов'
      }
    },
    {
      path: '/patientRoom/patientService/:id',
      component: () => import('@/views/patientRoom/components/patientService'),
      name: 'patientService',
      meta: {
        title: 'История пациентов'
      }
    },
    {
      path: '/patientRoom/patientConclusion/:id',
      component: () => import('@/views/patientRoom/components/patientConclusion'),
      name: 'patientConclusion',
      meta: {
        title: 'История пациентов'
      }
    },
    {
      path: '/patientRoom/dailyTreatment/:id',
      component: () => import('@/views/patientRoom/components/dailyTreatment'),
      name: 'dailyTreatment',
      meta: {
        title: 'История пациентов'
      },
    },
    {
      path: '/patientRoom/physiotherapy/:id',
      component: () => import('@/views/patientRoom/components/physiotherapy'),
      name: 'physiotherapy',
      meta: {
        title: i18n.t(`message.patient_histories`)
      },
    },
    {
      path: '/patientRoom/clientBalance/:id',
      component: () => import('@/views/patientRoom/components/clientBalance'),
      name: 'clientBalance',
      meta: {
        title: i18n.t(`message.patient_histories`)
      },
    },
    {
      path: '/patientRoom/finalConclusion/:id',
      component: () => import('@/views/patientRoom/components/finalConclusion'),
      name: 'finalConclusion',
      meta: {
        title: i18n.t(`message.patient_histories`)
      },
    }
    ]
  }]
}

export default schedule